module.exports = __webpack_public_path__ + "img/newicon10.d3d8aee3.svg";